import React, { useCallback } from 'react';
import { useOnFavoriteClick } from 'cityads-v3/hooks/offers';
import { Offer } from 'cityads-v3/types/offers';
import classes from './Offers.scss';

import OfferCard from './OfferCard';
import { OffersListProps } from './OffersList';



type OffersListCardsProps = OffersListProps
export default function OffersListCards({
  offers,
  customActions,
  customBody,
  customCardTitle,
  isFavoritesPage,
  linkSource,
  reloadFavoriteTotalCount,
  showActions,
  showTargetsTable,
}: OffersListCardsProps): JSX.Element {
  const favoriteClickAction = useOnFavoriteClick(null, null, reloadFavoriteTotalCount);
  const handleFavoriteClick = useCallback((id: Offer['id']) => () => {
    favoriteClickAction(id);
  }, [favoriteClickAction])

  return (
    <>
      {offers?.map((offer) => (
        <div key={offer.id} className={classes.offers__listoffer}>
          <OfferCard
            {...offer}
            manualFetch
            customActions={customActions}
            customBody={customBody}
            customTitle={customCardTitle}
            onFavoriteClick={handleFavoriteClick(offer.id)}
            linkSource={linkSource}
            showActions={showActions}
            showTargetsTable={showTargetsTable}
            isFavoritesPage={isFavoritesPage}
          />
        </div>
      ))}
    </>
  )
}
